import {LoginPage} from './login-page';
export function ForgotPasswordPage(_props: any) { return <LoginPage />; }
